export default __webpack_public_path__ + "static/other-0b46103028c6afc9f0e0f7a5de1aaa1c.jpg";